import { DashboardModuleListItem } from '@domain-group/suit-theme'

import { generateUrls } from '@hooks/useBrand'
import useCurrentUser from '@hooks/useCurrentUser'

import type { BrandModel } from '@models/types'

interface BrandListItemProps {
  brand: Partial<BrandModel>,
}
const BrandListItem = (props: BrandListItemProps) => {
  const { brand, brand: { id, title } } = props

  const { editBrandUrl, editBrandRelationsUrl } = generateUrls(brand)

  const { isBrandUser } = useCurrentUser()

  return (
    <DashboardModuleListItem
      href={isBrandUser ? editBrandUrl : editBrandRelationsUrl}
      title={title}
    >
      {/*
       // @ts-expect-error TS2339 */}
      <DashboardModuleListItem.TertiaryText>
        {`# ${id}`}
        {/*
       // @ts-expect-error TS2339 */}
      </DashboardModuleListItem.TertiaryText>
    </DashboardModuleListItem>
  )
}

export default BrandListItem
